import React, { useMemo, useEffect, useState } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { Header } from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
// import {Footer} from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
// import {QuickPanel} from "./extras/offcanvas/QuickPanel";
// import {QuickUser} from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
// import {StickyToolbar} from "./extras/StickyToolbar";
import { useLocation } from "react-router-dom";
// import { useSelector, shallowEqual } from "react-redux";

// Function to get page class name based on route
const getPageClassName = (pathname) => {
    if (!pathname) return 'page-home';
    
    // Remove leading slash and convert to lowercase
    const path = pathname.replace(/^\//, '').toLowerCase();
    
    // Handle specific routes
    const routeMappings = {
        'all-inventory': 'page-all-inventory',
        'my-inventory': 'page-my-inventory',
        '': 'page-home',
        '/': 'page-home'
    };
    
    // Check for exact matches first
    if (routeMappings[path]) {
        return routeMappings[path];
    }
    
    // For dynamic routes, extract the base path
    const segments = path.split('/');
    const basePath = segments[0];
    
    // Create class name from base path
    if (basePath) {
        return `page-${basePath}`;
    }
    
    return 'page-default';
};

export function Layout({ children }) {
    const uiService = useHtmlClassService();
    // Layout settings (cssClasses/cssAttributes)
    // const location = useLocation();
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
            subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true),
            contentExtended: objectPath.get(uiService.config, "content.extended")
        };
    }, [uiService]);

    const location = useLocation();

    // Apply body class based on current route
    useEffect(() => {
        const body = document.body;
        const pageClassName = getPageClassName(location.pathname);
        
        // Remove any existing page classes
        body.className = body.className.replace(/page-\S+/g, '');
        
        // Add the new page class
        body.classList.add(pageClassName);
        
        // Cleanup function to remove class when component unmounts
        return () => {
            body.classList.remove(pageClassName);
        };
    }, [location.pathname]);

    return layoutProps.selfLayout !== "blank" ? (
        <>
            {/*begin::Main*/}
            <HeaderMobile />
            <div className="d-flex flex-column flex-root">
                <Header />
                {/*begin::Page*/}
                <div className="body page">

                    {/* {layoutProps.asideDisplay && (location.pathname && (location.pathname === '/my-inventory' || location.pathname === '/all-inventory' || location.pathname === '/')) && (<Aside />)} */}
                    {layoutProps.asideDisplay && (<Aside />)}
                    {/*begin::Wrapper*/}
                    <div className={`d-flex flex-column flex-row-fluid wrapper${location && location.pathname == "/my-inventory" ? ' show_total_item_btn' : ''}`} id="kt_wrapper">

                        {/*begin::Content*/}
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            {layoutProps.subheaderDisplay && <SubHeader />}
                            {/*begin::Entry*/}
                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid page_mn">
                                    {/*begin::Container*/}
                                    <div className={layoutProps.contentContainerClasses}>
                                        {children}
                                    </div>
                                    {/*end::Container*/}
                                </div>
                            )}

                            {layoutProps.contentExtended && { children }}
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        {/* <Footer/> */}
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
            {/* <QuickUser/> */}
            {/* <QuickPanel/> */}
            <ScrollTop />
            {/* <StickyToolbar/> */}
            {/*end::Main*/}
            <LayoutInit />
        </>
    ) : (
        // BLANK LAYOUT
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}
